/*
 * サブシステム名：運用
 * 機能名：ログイン
 */

<template>
  <v-form>
    <v-container class="pa-0 ma-0" fluid fill-height>
      <v-card class="mx-auto"  min-height="60vh" style="border-radius: 10px;margin-top:3%;">
        <v-row no-gutters>
          <v-img src="@/assets/ddlogo.png" max-height="14vh" contain class="mt-5 mb-2"></v-img>
        </v-row>
        <v-row no-gutters>
          <v-col :cols=12>
            <div class="text-h6 px-5" style="color:black;">ログイン</div>
            <v-divider class="py-2"></v-divider>
          </v-col>
        </v-row>
        <v-row no-gutters v-show="isMultiCompanyMode === true">
          <v-col :cols=12>
            <v-row no-gutters >
              <v-col :cols=11 class="px-3">
                <dd-text-box
                  label="会社コード"
                  ref="kaishaCd"
                  v-model="kaishaCd"
                  prepend-icon="mdi-home"
                  :length="25"
                  :required="true"
                  :valueType="Ctrls.InputTypes.Number"
                />
              </v-col>
              <v-col :cols=1 class="px-2"></v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col :cols=12 class="px-3">
            <dd-text-box
              label="ユーザID"
              ref="jininCd"
              v-model="jininCd"
              prepend-icon="mdi-account-circle"
              :length="25"
              :required="true"
              :showRequire="false"
              :valueType="Ctrls.InputTypes.Alphanumeric"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col :cols=12 class="pl-9 mb-4">
            <dd-checkbox
              label="ユーザIDを記憶する"
              v-model="registUserId"
            />
          </v-col>
        </v-row>
        <p style="white-space:pre-wrap;"></p>
        <v-row no-gutters>
          <v-col :cols=12 class="px-3">
            <dd-password-box
              ref="password"
              label="パスワード"
              v-model="password"
              :required="true"
              :valueType="Ctrls.InputTypes.Alphanumeric"
              :append-icon="currentpassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="currentpassword ? 'text' : 'password'"
              @click:append="currentpassword = !currentpassword"
              prepend-icon="mdi-lock-outline"
              outlined dense
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col :cols=12 class="pl-9 mb-6">
            <dd-checkbox
              label="パスワードを記憶する"
              v-model="registPassword"
            />
          </v-col>
        </v-row>
        <p style="white-space:pre-wrap;"></p>
        <v-row no-gutters justify="center" class="px-2">
          <dd-login-button :isBeforeLogin="isBeforeLogin" @click="onClick" />
        </v-row>
        <v-row no-gutters justify="end" class="mt-2">
          <div class="version-text px-5">Ver.2.0.20260120</div>
        </v-row>
      </v-card>
    </v-container>
    <v-footer class="py-3" style="background:transparent;" app inset>
      <v-spacer></v-spacer>
      <a :href="filterExLink1URL">{{ filterExLink1Title }}</a><v-spacer></v-spacer>
      <a :href="filterExLink2URL">{{ filterExLink2Title }}</a><v-spacer></v-spacer>
      <a :href="filterExLink3URL">{{ filterExLink3Title }}</a><v-spacer></v-spacer>
      <a :href="filterExLink4URL">{{ filterExLink4Title }}</a><v-spacer></v-spacer>
      <a :href="filterExLink5URL">{{ filterExLink5Title }}</a><v-spacer></v-spacer>
      <a :href="filterExLink6URL">{{ filterExLink6Title }}</a><v-spacer></v-spacer>
    </v-footer>
  </v-form>
</template>
<script>
// import DdDefaultButton from '@/components/DdDefaultButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdTextBox from '@/components/DdTextBox'
import Logger from '@/rahmen/logger'
import effects from '@/rahmen/utils/effects'
import viewMixins from '@/mixins/viewMixins'
import DdPasswordBox from '@/components/DdPasswordBox'
import DdLoginButton from '@/components/DdLoginButton'
import messages from '@/ddv2.library/messages'

import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  mixins: [
    viewMixins
  ],
  components: {
    DdPasswordBox,
    DdLoginButton,
    DdCheckbox,
    DdTextBox
  },
  data: () => ({
    jininCd: '',
    password: '',
    kaishaCd: '',
    startPage: 'dashboard',
    registUserId: false,
    registPassword: false,
    currentpassword: false,
    isBeforeLogin: true
  }),
  computed: {
    ...mapGetters({
      registerdUserid: 'usersBeforeLogin/userId',
      registerdPassword: 'usersBeforeLogin/password',
      msyssystemconfig: 'DDMasters/msysSystemConfig'
    }),
    isMultiCompanyMode: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'multi_company_mode'
      })
      if (ret.length > 0 && ret[0].configValue1 === '1') {
        return true
      }
      return false
    },
    filterExLink1Title: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_1'
      })
      if (ret.length !== 0) {
        return ret[0].configTitle
      }
      return ''
    },
    filterExLink1URL: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_1'
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    },
    filterExLink2Title: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_2'
      })
      if (ret.length !== 0) {
        return ret[0].configTitle
      }
      return ''
    },
    filterExLink2URL: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_2'
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    },
    filterExLink3Title: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_3'
      })
      if (ret.length !== 0) {
        return ret[0].configTitle
      }
      return ''
    },
    filterExLink3URL: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_3'
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    },
    filterExLink4Title: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_4'
      })
      if (ret.length !== 0) {
        return ret[0].configTitle
      }
      return ''
    },
    filterExLink4URL: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_4'
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    },
    filterExLink5Title: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_5'
      })
      if (ret.length !== 0) {
        return ret[0].configTitle
      }
      return ''
    },
    filterExLink5URL: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_5'
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    },
    filterExLink6Title: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_6'
      })
      if (ret.length !== 0) {
        return ret[0].configTitle
      }
      return ''
    },
    filterExLink6URL: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_6'
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    }
  },
  created () {
    console.log('LOGIN')

    // スーパーリロード
    const href = window.location.href
    window.location.href = href

    this.$store.dispatch('users/flushUserInfo')
    this.$store.dispatch('system/setViewTitle', 'ログイン')
    this.$store.dispatch('DDMasters/loadMasters', { list: ['msysmessage', 'msyssystemconfig'], version: 1 })
    this.$store.dispatch('DDMasters/restoreMasters')
    this.setDefaultCompanyCode()
  },
  mounted () {
    this.isBeforeLogin = true
    this.logger = new Logger('token', 'name')
    this.logger.debug('Login.mounted', { loginId: this.loginId, password: this.password })
    // loadMasters: ['msysmessage']
    this.$store.dispatch('usersBeforeLogin/loadDatas').then(() => {
      if (this.registerdUserid !== '') {
        this.registUserId = true
        this.jininCd = this.registerdUserid
      }
      if (this.registerdPassword !== '') {
        this.registPassword = true
        this.password = this.registerdPassword
      }
    }).catch()
  },
  methods: {
    onClick: function () {
      this.isBeforeLogin = false

      console.log('onClick', this.msyssystemconfig)
      this.$store.dispatch('system/clearMessage')
      const isvalid = this.validateAll(this.$refs)
      console.log('validated', isvalid, this.$refs)
      this.setDefaultStartPage()
      if (!isvalid) { return }
      effects.loadStart()
      console.log('post')
      this.HttpClient.post('/api/v1/mstjinin/trylogin', {
        jininCd: this.jininCd,
        password: this.password,
        kaishaCd: this.kaishaCd
      })
        .then((data) => {
          console.log('login', data, data.isValid, data.isExistsPayload)

          if (!data.isValid || !data.isExistsPayload) {
            console.log('login error route', data.summaryMessage)
            this.setInvalidMessage(this.$refs, data.invalidList)
            const emsg = {
              message: data.summaryMessage
            }
            console.log('login error route2', emsg)
            this.$store.dispatch('system/setMessage', emsg)
            this.isBeforeLogin = true
            effects.loadComplete()
            return
          }
          console.log('login ok clear message')
          this.$store.dispatch('system/clearMessage')
          console.log('login ok get user info')
          const userInfo = data.payload.loginInfo
          userInfo.eigyoshoKbn = data.payload.loginInfoAddon.eigyoshoKbn
          userInfo.torihikisakiId = data.payload.loginInfoAddon.torihikisakiId
          userInfo.torihikisakiCd = data.payload.loginInfoAddon.torihikisakiCd
          console.log('loginInfo', userInfo)
          userInfo.faceImage = data.payload.mstFaceImage || {}
          console.log('faceImage', userInfo.faceImage)

          this.$store.dispatch('users/tryLogin', userInfo).then(() => {
            this.$store.dispatch('DDMasters/saveMasters', data.payload).then(() => {
              let saveUserId = ''
              let savePassword = ''

              if (this.registUserId) {
                saveUserId = this.jininCd
              }
              if (this.registPassword) {
                savePassword = this.password
              }
              // 入力されたuid,パスワードをindexedDbに保存
              this.$store.dispatch('usersBeforeLogin/saveDatas', { userId: saveUserId, password: savePassword }).then(() => {
                this.$router.push('/' + this.startPage)
              })
            })
          })
        }).catch(function (error) {
          const m = messages.getInfo('COME0001')
          this.$store.dispatch('system/setMessage', m)
          console.log('post error')
          console.log(error)
          this.isBeforeLogin = true
          effects.loadComplete()
        })
    },
    setDefaultCompanyCode: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'default_kaisha_cd'
      })
      if (ret.length > 0 && ret[0].configValue1 !== '') {
        this.kaishaCd = ret[0].configValue1
      } else {
        this.kaishaCd = '0010'
      }
    },
    setDefaultStartPage: function () {
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'default_start_page'
      })
      if (ret.length > 0 && ret[0].configValue1 !== '') {
        this.startPage = ret[0].configValue1
      } else {
        this.startPage = 'dashboard'
      }
    }
  }
}
</script>
<style scoped>
.version-text {
  font-size: small;
  font-family: Verdana;
  font-weight: bold;
}
</style>
